module.exports = __webpack_public_path__ + "static/media/velocidad.5932ceec.svg";